import { useCallback, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router'
import { WaterTestStripSelector } from '../../store/waterTestStrip/waterTestStrip.selector'
import { WaterTestStripActions } from '../../store/waterTestStrip/waterTestStrip.slice'

export type UploadState = 'options' | 'upload' | 'analysis' | 'camera' | 'completed'

export const useUpload = () => {
  const [currentState, setCurrentState] = useState<UploadState>('options')
  const [uploadedFile, setUploadedFile] = useState<File | null>(null)
  const [previewImage, setPreviewImage] = useState<string | null>(null)

  const dispatch = useDispatch()
  const navigate = useNavigate()
  const loading = useSelector(WaterTestStripSelector.loading)
  const error = useSelector(WaterTestStripSelector.error)

  const handleImageDrop = useCallback((acceptedFiles: File[]) => {
    const file = acceptedFiles[0]
    if (file) {
      setUploadedFile(file)
      const reader = new FileReader()
      reader.onload = () => {
        setPreviewImage(reader.result as string)
      }
      reader.readAsDataURL(file)
    }
  }, [])

  const resetUpload = () => {
    setUploadedFile(null)
    setPreviewImage(null)
    setCurrentState('options')
    dispatch(WaterTestStripActions.resetWaterTestStripData())
  }

  const handleAnalyze = async (shouldAnalyze?: boolean) => {
    if (!uploadedFile) return
    shouldAnalyze ? setCurrentState('analysis') : setCurrentState('completed')
    const request = await dispatch(WaterTestStripActions.uploadAndAnalyzeImageAsync(uploadedFile) as any)
    if(WaterTestStripActions.uploadAndAnalyzeImageAsync.fulfilled.match(request)){
      setUploadedFile(null)
      setPreviewImage(null)
      if (shouldAnalyze) {
        navigate(`/profile/overview`)
      }
    }

  }

  return {
    currentState,
    setCurrentState,
    capturedImage: previewImage,
    isAnalyzing: loading,
    error,
    handleAnalyze,
    handleImageDrop,
    resetUpload,
  }
}
